import { IField } from 'utils/interfaces/IField';
import InputTypes from 'utils/enums/inputTypes';

const profiles: IField[] = [
    {
        presentation: 'Nome',
        label: 'Nome do Perfil',
        name: 'name',
        type: InputTypes.text,
        columns: 3
    }
];

export default profiles;
